<template>
<div class="similar_anime_block">
      <div class="related-swiper-container">
        <details data-count="69" class="related_details">
          <summary class="dtip"><h3>Связанные</h3></summary>
          <div class="related-swiper-wrapper">
              <div v-for="anime in animeList" :key="anime.id" class="related_swiper-slide">
                <a :href="originUrl + '/' + (anime.anime == null ? anime_id : anime.anime.id)">
                  <img :src="'https://shikimori.one' + (anime.anime == null ? anime.manga.image.original : anime.anime.image.original)">
                </a>
                <p>{{ anime.anime == null ? anime.manga.russian : anime.anime.russian }}</p>
              </div>
          </div>
          <!-- Add Pagination -->
          <div class="swiper-pagination"></div>
          </details>
      </div>
    
      
</div>   
</template>

<script>
import axios from 'axios';


export default {
  props: {
    anime_id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      originUrl: window.location.origin,
      title: "",
      animeList: []
    };
  },
  mounted() {
    axios
      .get(`https://shikimori.one/api/animes/${this.anime_id}/related`)
      .then(response => {
        for(let i = 0;i < response.data.length;i++){
          if(response.data[i].manga === null){
            this.animeList.push(response.data[i]);
          }
        }  
      })
      .catch(error => {
      }); 
  }
};
</script>

<style>
.related_details::-webkit-scrollbar {
  width: 9px;            
}
.related_details::-webkit-scrollbar-track {
  background: transparent;       
}
.related_details::-webkit-scrollbar-thumb {
  background-color: #0d6efd;    
  border-radius: 20px;       
}

.similar_anime_block{
  padding: 0 20px;
}

.related_anime{
  position: relative;
  z-index: 10;
}

.my-slider{
  position: relative;
  z-index: 10;
}

.related-swiper-container{
  /*overflow: auto;*/
  margin: 0 150px;
}

.related-swiper-wrapper{
  max-height: 400px;
  margin-top: 20px;
}

.related_swiper-slide{
  display: flex;
  margin-bottom: 20px;
}

.related_swiper-slide img{
  width: 80px;
  border-radius: 8px;
}

.related_swiper-slide p{
  margin-top: 0;
  margin-left: 20px;
}


.related_details{
  overflow: auto;
  cursor: pointer;
}

.related_details summary h3{
  display: inline;
  transform: translate(19px, -42px);
}

@media only screen and (max-width: 600px) {
  .related_details::-webkit-scrollbar {
    width: 4px;            
  }

  .swiper-container{
    overflow: hidden;
    margin: 0;
  /*  width: 100vh;*/
  }

  .related-swiper-container {
      margin: 0 20px;
  }

  .similar_anime_block{
    padding: 0;
  }

}
</style>